// extracted by mini-css-extract-plugin
module.exports = {"validationTip":"_4801b4f","valid":"_8ea6f77","error":"_9da4fc1"};